import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          
          <motion.div 
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-12 lg:mb-0"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">{t('about.title')}</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              {t('about.desc')}
            </p>
            
            <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
              {t('about.stats').map((stat, idx) => (
                <div key={idx} className="bg-gray-50 p-4 rounded-xl text-center border border-gray-100">
                  <div className="text-3xl font-bold text-blue-600 mb-1">{stat.value}</div>
                  <div className="text-sm font-medium text-gray-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="absolute inset-0 bg-blue-600 rounded-3xl transform translate-x-4 translate-y-4 opacity-20"></div>
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1776371147086-image.png" 
              alt="Founder at Immigration Seminar" 
              className="relative rounded-3xl shadow-2xl object-cover object-top h-[500px] w-full"
            />
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;